<template>
  <section id="manuslist-generator" class="content white large-padding scrollnav">
    <form class="hide-for-print" @submit.prevent="handleSubmit" spellcheck="false">
      <TheLoader :active="true" v-if="loading"/>
      <fieldset style="margin: 0;" v-else>
        <div class="grid-x grid-padding-x">
          <TheSelectInput v-model="form.avdelingsid" containerClassName="cell large-2" label="Avdeling" name="Avdelingsid" required :items="avdelingOpts" :disabled="loading"/>

          <TheAutoCompleteInput v-model.trim="form.code"
            ref="auksjon_input"
            containerClassName="cell large-3"
            name="Auksjon"
            v-validate="'required'"
            required
            :placeholder="'Velg auksjon'"
            :label="'Tilhørende auksjon'"
            :onInputCallback="onAuksjonSearchInput"
            :onSelectCallback="onAuksjonSearchSelected"
            :disabled="loading || form.avdelingsid === null"
            :debounce="750"
            :minquery="2"
          >
            <div slot="item" slot-scope="props">
              <strong>{{props.item.Auksjon}}</strong>, {{props.item.Beskrivelse}}
              <span v-if="props.item.Auksjon_dato">
                ({{ props.item.Auksjon_dato | avantidate }})
              </span>
            </div>
          </TheAutoCompleteInput>

          <TheIntegerInput v-if="showKontraktFilter" containerClassName="cell shrink" label="Kontraktnr" name="Kontraktnr" v-model.trim="form.kontraktnr" :disabled="loading || form.avdelingsid === null"/>

          <TheSelectInput v-model="form.sort" containerClassName="cell large-1" label="Sorter på" name="sort" :items="sortOpts" :disabled="loading || form.avdelingsid === null"/>
          <TheSelectInput v-model="form.direction" containerClassName="cell large-1" label="Stigende/synkende" name="direction" data-vv-validate-on="input" :items="directionOpts" :disabled="loading || form.avdelingsid === null"/>

          <div class="cell auto">
            <label>&nbsp;</label>
            <template v-if="form.code">
              <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="handleSubmit()" class="button primary submit tiny">Ok</a>
              <a v-else-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit tiny loading">Ok <span class="loader-spinner"></span></a>
              <a v-else-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit tiny" disabled>Ok</a>

              <template v-if="!found || !found.objects || found.objects.length < 1">
                <a href="javascript:;" class="button primary submit tiny" disabled style="margin-left: 0.25rem;">Generer trykkfil</a>
                <a href="javascript:;" class="button primary submit tiny" disabled style="margin-left: 0.25rem;">Skriv ut</a>
              </template>
              <template v-else-if="exporting">
                <a href="javascript:;" class="button primary submit tiny loading" style="margin-left: 0.25rem;">Last ned <span class="loader-spinner"></span></a>
                <a @click="handlePrint()" href="javascript:;" class="button primary submit tiny" style="margin-left: 0.25rem;">Skriv ut</a>
              </template>
              <template v-else>
                <a @click="handleExport()" href="javascript:;" class="button primary submit tiny" style="margin-left: 0.25rem;">Generer trykkfil</a>
                <a @click="handlePrint()" href="javascript:;" class="button primary submit tiny" style="margin-left: 0.25rem;">Skriv ut</a>
              </template>
            </template>
            <template v-else>
              <a href="javascript:;" class="button primary submit tiny" disabled>Ok</a>
            </template>
          </div>
        </div>

        <div class="grid-x grid-padding-x">
          <div class="cell shrink">
            <p style="margin-top: 1px;">Bilde:</p>
          </div>
          <div class="cell shrink">
            <input id="image-none" type="radio" v-model="imageSize" :value="'image-none'"> <label style="display: inline;" for="image-none">Inga</label>
          </div>
          <div class="cell shrink">
            <input id="image-small" type="radio" v-model="imageSize" :value="'image-small'"> <label style="display: inline;" for="image-small">Små</label>
          </div>
          <div class="cell shrink">
            <input id="image-medium" type="radio" v-model="imageSize" :value="'image-medium'"> <label style="display: inline;" for="image-medium">Mellan</label>
          </div>
          <div class="cell shrink">
            <input id="image-large" type="radio" v-model="imageSize" :value="'image-large'"> <label style="display: inline;" for="image-large">Stora</label>
          </div>
          <div class="cell shrink">
            <p style="margin-top: 1px;"></p>
          </div>
          <div class="cell shrink">
            <input type="checkbox" id="photo" true-value="F" false-value="T" v-model="photo"> <label style="display: inline;" for="photo">Vis Objekter som mangler bilder</label>
          </div>
        </div>

      </fieldset>
    </form>

    <template v-if="found">
      <div id="manuslist-page-content">
        <div class="grid-x" style="margin-bottom: 1rem;">
          <div class="print-header cell auto">
            <span v-if="Number(found.auction.Avdelingsid) < 1">
              Auksjon: {{found.auction.Auksjon}} - {{found.auction.Beskrivelse}}
              - {{found.auction.Auksjon_dato | avantidate}},
              Ant. obj: {{objectCount}}, Tot. vurd: {{objectTotalVurdering}}
            </span>
            <span v-else>
              Auksjon: {{found.auction.Auksjon}} - {{found.auction.Beskrivelse}},
              Ant. obj: {{objectCount}}, Tot. vurd: {{objectTotalVurdering}}
            </span>
          </div>
          <div class="cell shrink hide-for-print">
            <span class="opacity-60" v-if="this.found.eurorate">
              <em style="font-size: 0.7rem">
                &euro;{{this.found.eurorate.Kurs | thousandsFloat(4)}}
                ({{this.found.eurorate.Dato | avantidate}})
                </em>
            </span>
          </div>
        </div>

        <!-- Should probably make component for each and one of the tables -->
        <template v-if="this.$route.name === 'Manusliste'">
          <table id="tab-manusliste" class="manuslist experts" :class="imageSize" style="table-layout: fixed; page-break-inside: auto;">
            <thead style="display: table-header-group">
              <tr>
                <th class="th-div-1 first-col">Kat.nr</th>
                <th class="th-div-2 text-col">Tekst</th>
                <th class="th-div-3 location-col">Sone</th>
                <th class="th-div-4 align-center">Tekst ok</th>
                <th class="th-div-5 align-center">Minstepris</th>
                <th class="th-div-6 align-center">Vurdering lav</th>
                <th class="th-div-7 align-center">Vurdering høy</th>
                <th class="th-div-8 align-right">Objektnr</th>
                <th class="th-div-9 kat align-right">Kat.</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="9">
                  <template v-for="item in filteredObjects">
                    <div style="" class="tr-div header" :key="'a-' + item.Objektid">
                      <div class="td-div td-div-1 first-col">{{item.Katalognr || '-'}}</div>
                      <div class="td-div td-div-2 text-col">
                        <template v-if="itemKunstner(item)">
                          {{itemKunstnerName(item)}}
                        </template>
                        <template v-else>
                          <div class="show-for-print pre">{{item.Katalogtekst1}}</div>
                          <input type="text" class="hide-for-print editable" spellcheck="false" :value="item.Katalogtekst1" @blur="event => onBlur(event, 'Katalogtekst1', item)" />
                        </template>
                      </div>
                      <div class="td-div td-div-3 location-col">{{item.lokasjon ? item.lokasjon.Lokasjonkode : '-'}}</div>
                      <div class="td-div td-div-4 align-center">
                        <span class="show-for-print">{{item.Tekst_ok === 'T' ? 'J' : 'N'}}</span>
                        <input class="hide-for-print" type="checkbox" spellcheck="false" :value="true" :checked="item.Tekst_ok == 'T'" @change="event => onCheckboxChange(event, 'Tekst_ok', item)" />
                      </div>
                      <div class="td-div td-div-5 align-center">{{item.Minstepris | thousands}}</div>
                      <div class="td-div td-div-6 align-center">{{item.Vurderingspris2 | thousands}}</div>
                      <div class="td-div td-div-7 align-center">{{item.Vurderingspris1 | thousands}}</div>
                      <div class="td-div td-div-8 align-right">{{item.Objektnr}}</div>
                      <div class="td-div td-div-9 kat align-right">{{item.Kategori || ''}}</div>
                    </div>
                    <div style="" class="tr-div content" :key="'b-' + item.Objektid">
                      <div class="td-div td-div-1 first-col">
                        <img v-if="itemThumb(item)" :src="itemThumb(item)"/>
                      </div>
                      <div class="td-div td-div-span-4 text-col" colspan="4" style="position: relative; word-wrap: break-word; overflow-wrap: break-word;">
                        <span class="hide-for-print icon-saving" :class="{'active': savingItems.hasOwnProperty(item.Objektid)}">Lagrer...</span>
                        <template v-if="itemKunstner(item)">
                          <div class="newline" v-if="itemKunstnerText(item)">{{itemKunstnerText(item)}}</div>
                          <div class="show-for-print pre">{{item.Katalogtekst1}}</div>
                          <input type="text" spellcheck="false" class="hide-for-print editable" placeholder="Katalogtekst1" :value="item.Katalogtekst1" @blur="event => onBlur(event, 'Katalogtekst1', item)" />
                        </template>

                        <div class="show-for-print pre">{{item.Objekt3}}</div>
                        <textarea class="hide-for-print" spellcheck="false" placeholder="Objekt3" :value="item.Objekt3" @input="onInputTextarea" @blur="event => onBlur(event, 'Objekt3', item)" />

                        <div class="show-for-print pre">{{item.Objekt1}}</div>
                        <textarea class="hide-for-print" spellcheck="false" placeholder="Objekt1" :value="item.Objekt1" @input="onInputTextarea" @blur="event => onBlur(event, 'Objekt1', item)" />

                        <div class="show-for-print pre">{{item.Katalogtekst2}}</div>
                        <textarea class="hide-for-print" spellcheck="false" placeholder="Katalogtekst2" :value="item.Katalogtekst2" @input="onInputTextarea" @blur="event => onBlur(event, 'Katalogtekst2', item)" />
                      </div>
                      <div class="td-div td-div-6 align-center">
                        {{ itemAmountToEuro(item.Vurderingspris2) }}
                      </div>
                      <div class="td-div td-div-7 align-center">
                        {{ itemAmountToEuro(item.Vurderingspris1) }}
                      </div>
                      <div class="td-div td-div-8">&nbsp;</div>
                      <div class="td-div td-div-9">&nbsp;</div>
                    </div>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </template>

        <template v-else-if="this.$route.name === 'ManuslisteKunde'">
          <table class="manuslist kunder" :class="imageSize" style="table-layout: fixed; page-break-inside: auto;">
            <thead style="display: table-header-group">
              <tr>
                <th class="th-div2-1 first-col">Kat.nr</th>
                <th class="th-div2-2 text-col">Tekst</th>
                <th class="th-div2-3 align-center">Vurdering lav</th>
                <th class="th-div2-4 align-center">Vurdering høy</th>
                <th class="th-div2-5 align-right">Objektnr</th>
                <th class="th-div2-6 kat align-right">Kat.</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="6">
                    <template v-for="item in filteredObjects">
                      <div style="" class="tr-div header" :key="'a-' + item.Objektid">
                        <div class="td-div td-div2-1 first-col">{{item.Katalognr || '-'}}</div>
                        <div class="td-div td-div2-2 text-col">
                          <template v-if="itemKunstner(item)">
                            {{itemKunstnerName(item)}}
                          </template>
                          <template v-else>
                            <div class="show-for-print pre">{{item.Katalogtekst1}}</div>
                            <input type="text" spellcheck="false" class="hide-for-print editable" :value="item.Katalogtekst1" @blur="event => onBlur(event, 'Katalogtekst1', item)" />
                          </template>
                        </div>
                        <div class="td-div td-div2-3 align-center">{{item.Vurderingspris2 | thousands}}</div>
                        <div class="td-div td-div2-4 align-center">{{item.Vurderingspris1 | thousands}}</div>
                        <div class="td-div td-div2-5 align-right">{{item.Objektnr}}</div>
                        <div class="td-div td-div2-6 kat align-right">{{item.Kategori || ''}}</div>
                      </div>
                      <div style="" class="tr-div content" :key="'b-' + item.Objektid">
                        <div class="td-div td-div2-1 first-col">
                          <img v-if="itemThumb(item)" :src="itemThumb(item)"/>
                        </div>
                        <div class="td-div td-div2-2 text-col" style="position: relative;">
                          <span class="hide-for-print icon-saving" :class="{'active': savingItems.hasOwnProperty(item.Objektid)}">Lagrer...</span>
                          <template v-if="itemKunstner(item)">
                            <div class="newline" v-if="itemKunstnerText(item)">{{itemKunstnerText(item)}}</div>
                            <div class="show-for-print pre">{{item.Katalogtekst1}}</div>
                            <input type="text" spellcheck="false" class="hide-for-print editable" placeholder="Katalogtekst1" :value="item.Katalogtekst1" @blur="event => onBlur(event, 'Katalogtekst1', item)" />
                          </template>

                          <div class="show-for-print pre">{{item.Objekt3}}</div>
                          <textarea class="hide-for-print" spellcheck="false" placeholder="Objekt3" :value="item.Objekt3" @input="onInputTextarea" @blur="event => onBlur(event, 'Objekt3', item)" />

                          <div class="show-for-print pre">{{item.Objekt1}}</div>
                          <textarea class="hide-for-print" spellcheck="false" placeholder="Objekt1" :value="item.Objekt1" @input="onInputTextarea" @blur="event => onBlur(event, 'Objekt1', item)" />

                          <div class="show-for-print pre">{{item.Katalogtekst2}}</div>
                          <textarea class="hide-for-print" spellcheck="false" placeholder="Katalogtekst2" :value="item.Katalogtekst2" @input="onInputTextarea" @blur="event => onBlur(event, 'Katalogtekst2', item)" />
                        </div>
                        <div class="td-div td-div2-3 align-center">
                          {{ itemAmountToEuro(item.Vurderingspris2) }}
                        </div>
                        <div class="td-div td-div2-4 align-center">
                          {{ itemAmountToEuro(item.Vurderingspris1) }}
                        </div>
                        <div class="td-div td-div2-5">&nbsp;</div>
                        <div class="td-div td-div2-6">&nbsp;</div>
                      </div>
                    </template>
                  </td>
                </tr>
            </tbody>
          </table>
        </template>
      </div>
    </template>
  </section>
</template>

<script>
import ObjektService from '@/services/ObjektService'
import AuksjonService from '@/services/AuksjonService'
import InstillingerService from '@/services/InstillingerService'
import TheAutoCompleteInput from '../../Inputs/TheAutoCompleteInput'
import TheLoader from '../../TheLoader.vue'
import moment from 'moment'
import accounting from 'accounting-js'
import fileDownload from 'js-file-download'

export default {
  name: 'ManuslistGenerator',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInput,
    TheLoader
  },
  data () {
    return {
      form: {
        code: null,
        avdelingsid: null,
        kontraktnr: null,
        sort: 'kunstner.Navn',
        direction: 'asc'
      },
      sortOpts: [
        { key: 'kunstner.Navn', val: 'Kunstner' },
        { key: 'Objektnr', val: 'Objektnr' },
        { key: 'Katalognr', val: 'Katalognr' }
      ],
      directionOpts: [
        { key: 'asc', val: 'Stigende' },
        { key: 'desc', val: 'Synkende' }
      ],
      avdelingOpts: [],
      imageSize: 'image-small',
      savingItems: {},
      exporting: false,
      loading: true,
      found: null,
      showKontraktFilter: false,
      photo: 'T'
    }
  },
  computed: {
    title: function () {
      return this.$route.meta.title
    },
    objectCount: function () {
      return this.found && this.found.objects ? this.found.objects.length : 0
    },
    objectTotalVurdering: function () {
      let total = 0

      if (this.objectCount) {
        this.found.objects.forEach(o => {
          total += (o.Vurderingspris2 ? o.Vurderingspris2 : 0)
        })
      }

      if (total) {
        return accounting.formatNumber(total, { precision: 0, thousand: ' ' }) + 'kr / ' + this.itemAmountToEuro(total)
      }

      return 0
    },
    filteredObjects: function () {
      if (!this.photo.length || this.photo === 'T') {
        return this.found.objects
      }

      return this.found.objects.filter(o => {
        return o.Fototatt === this.photo
      })
    }
  },
  watch: {
    'form.avdelingsid': function (newVal, oldVal) {
      // Reset auction code on avdeling change ... but skip on init (oldVal = null) when it is set from localstorage.
      if (oldVal !== null) {
        this.form.code = null
      }

      if (newVal && parseInt(newVal) === 2) {
        this.showKontraktFilter = true
      } else {
        this.showKontraktFilter = false
        this.form.kontraktnr = null
      }
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    loadLastSettings: function () {
      try {
        const retval = JSON.parse(localStorage.getItem('manuslist-cfg') || {})
        const key = this.$route.name || 'default'

        if (!retval.hasOwnProperty(key)) {
          return {}
        }

        return retval[key]
      } catch (e) {
        return {}
      }
    },
    saveLastSettings: function (data) {
      let stored

      try {
        stored = localStorage.getItem('manuslist-cfg')
          ? JSON.parse(localStorage.getItem('manuslist-cfg'))
          : {}
      } catch (e) {
        stored = {}
      }

      try {
        const key = this.$route.name || 'default'

        stored[key] = data

        localStorage.setItem('manuslist-cfg', JSON.stringify(stored))
      } catch (e) {
        // Ignore
        console.log('Save to local storage error:')
        console.log(e)
      }
    },
    onInputTextarea (event) {
      // Resize textare to content height
      try {
        if (event.target && event.target.style) {
          event.target.style.height = 'auto'
          event.target.style.height = `${(event.target.scrollHeight + 2)}px`
        }
      } catch (e) {
        // Ignore
      }
    },
    onBlur: function (event, key, item) {
      this.saveItemKey(item, key, event.target.value)
    },
    onCheckboxChange: function (event, key, item) {
      this.saveItemKey(item, key, event.target.checked ? 'T' : 'F')
    },
    saveItemKey: function (item, key, value) {
      const current = this.found ? this.found.objects.find(o => o.Objektid === item.Objektid) : null
      const updated = value ? this._.trim(value) : ''

      if (!current) {
        return
      }

      // Rollback value
      const previous = current[key]

      if (current[key] !== updated) {
        const post = { [key]: updated }

        this.$set(current, key, updated)

        this.$set(this.savingItems, current.Objektid, true)

        ObjektService.update(current.Objektid, post)
          .then(response => {
            // After successful save
            console.log('Success')
            console.log(response)
          })
          .catch(error => {
            console.log('Unable to save...')
            console.log(error)

            this.$set(current, key, previous)
          })
          .then(() => {
            this.$delete(this.savingItems, current.Objektid)
          })
      }
    },

    /* Start Item In Table methods... */
    itemAmountToEuro: function (amount, decimals = 0) {
      if (this.found.eurorate) {
        if (amount !== undefined && amount !== null && amount !== '') {
          return '€' + accounting.formatNumber(Math.round(amount / this.found.eurorate.Kurs), { precision: decimals, thousand: ' ' })
        }

        return '€0'
      }

      return '-'
    },
    itemThumb: function (item) {
      if (item.photos && item.photos.thumb && item.photos.thumb.length > 0) {
        return item.photos.thumb[0]
      }

      return ''
    },
    itemKunstner: function (item) {
      return item.kunstner
    },
    itemKunstnerName: function (item) {
      if (item.kunstner.name_reverse) {
        const retval = item.kunstner.name_reverse.replace(/, /, ' ')

        return retval.toUpperCase()
      }

      return ''
    },
    itemKunstnerText: function (item) {
      if (item.kunstner) {
        let kunstnerTitle = []

        if (item.kunstner.Fodested && item.kunstner.Fodeaar) {
          kunstnerTitle.push(item.kunstner.Fodested + ' ' + item.kunstner.Fodeaar)
        } else if (item.kunstner.Fodested) {
          kunstnerTitle.push(item.kunstner.Fodested)
        } else if (item.kunstner.Fodeaar) {
          kunstnerTitle.push(item.kunstner.Fodeaar)
        }

        if (item.kunstner.Dodssted && item.kunstner.Dodsaar) {
          kunstnerTitle.push(item.kunstner.Dodssted + ' ' + item.kunstner.Dodsaar)
        } else if (item.kunstner.Dodssted) {
          kunstnerTitle.push(item.kunstner.Dodssted)
        } else if (item.kunstner.Dodsaar) {
          kunstnerTitle.push(item.kunstner.Dodsaar)
        }

        if (kunstnerTitle.length > 0) {
          return kunstnerTitle.join(' - ')
        }
      }

      return null
    },
    /* End Item In Table methods... */

    initialTextareaResize: function () {
      setTimeout(function () {
        try {
          const elements = document.querySelectorAll('textarea')

          if (elements && elements.length > 0) {
            elements.forEach(el => {
              if (el.style) {
                el.style.height = 'auto'
                el.style.height = `${el.scrollHeight + 2}px`
              }
            })
          }
        } catch (e) {
          console.log('Unable to resize textareas...')
          console.log(e)
        }
      })
    },
    exportManusliste: function () {
      return new Promise((resolve, reject) => {
        const data = []
        const auction = this.found.auction

        if (auction) {
          const totCount = this.objectCount
          const totVurd = this.objectTotalVurdering

          if (Number(auction.Avdelingsid) < 1) {
            const auctionDate = this.$options.filters.avantidate(auction.Auksjon_dato)

            data.push(`Auksjon: ${auction.Auksjon} - ${auction.Beskrivelse} - ${auctionDate}, Ant. obj: ${totCount}, Tot. vurd: ${totVurd}`)
          } else {
            data.push(`Auksjon: ${auction.Auksjon} - ${auction.Beskrivelse}, Ant. obj: ${totCount}, Tot. vurd: ${totVurd}`)
          }

          data.push('\n')
        }

        this.found.objects.forEach(item => {
          if (item.Katalognr) {
            data.push(item.Katalognr)
          }

          if (this.itemKunstner(item)) {
            data.push(this.itemKunstnerName(item))

            if (this.itemKunstnerText(item)) {
              data.push(this.itemKunstnerText(item))
            }

            // Add objektnr after kunstner
            data.push(item.Objektnr)

            data.push('')
            data.push(item.Katalogtekst1)
          } else {
            // Add objektnr first
            data.push(item.Objektnr)
            data.push(item.Katalogtekst1)
            data.push('')
          }

          if (item.Objekt3) {
            data.push(item.Objekt3)
          }
          if (item.Objekt1) {
            data.push(item.Objekt1)
          }
          if (item.Katalogtekst2) {
            data.push(item.Katalogtekst2)
          }

          const vurderingLine = []
          if (item.Vurderingspris2 > 0 && item.Vurderingspris1 > 0) {
            vurderingLine.push(
              this.$options.filters.thousands(item.Vurderingspris2) + ' - ' +
              this.$options.filters.thousands(item.Vurderingspris1) + ' / ' +
              this.itemAmountToEuro(item.Vurderingspris2) + ' - ' +
              this.itemAmountToEuro(item.Vurderingspris1)
            )
          } else if (item.Vurderingspris2 > 0) {
            vurderingLine.push(
              this.$options.filters.thousands(item.Vurderingspris2) + ' / ' +
              this.itemAmountToEuro(item.Vurderingspris2)
            )
          } else if (item.Vurderingspris1 > 0) {
            vurderingLine.push(
              this.$options.filters.thousands(item.Vurderingspris1) + ' / ' +
              this.itemAmountToEuro(item.Vurderingspris1)
            )
          } else {
            vurderingLine.push(
              this.$options.filters.thousands(0) + ' / ' +
              this.itemAmountToEuro(0)
            )
          }

          if (vurderingLine.length > 0) {
            data.push('')
            data.push(vurderingLine)
          }

          data.push('')
          data.push('')
        })

        // Make txt and force download...
        const text = data.join('\n')
        const blob = new Blob([text], {
          type: 'text/plain;charset=utf-8'
        })

        fileDownload(blob, 'manusliste-trykkeri-' + moment().format('DDMMYY.Hms') + '.txt')

        resolve()
      })
    },
    handlePrint: function () {
      window.print()
    },
    handleExport: function () {
      if (!this.found || !this.found.objects || this.found.objects.length < 1) {
        this.$helpers.showErrorAlert('Feil', 'Ingen objekter at skrive ut')
        return
      }

      this.exporting = true
      this.exportManusliste()
        .then(() => {
          this.exporting = false
        })
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            console.log('POST the fetch data', this.form)

            ObjektService.getManuslist(this.form)
              .then(response => {
                console.log('Success')
                console.log(response)

                if (response.data.auction && response.data.objects && response.data.objects.length > 0) {
                  this.found = {
                    eurorate: response.data.eurorate || null,
                    auction: response.data.auction,
                    objects: response.data.objects || []
                  }
                } else {
                  throw new Error('Kunne ikke finne objekter...')
                }
              })
              .catch(error => {
                console.log('Error')
                console.log(error)

                const custom = this.$helpers.getCustomErrors(error) || {}

                if (custom.Auksjon) {
                  this.$helpers.showErrorAlert('Feil', custom.Auksjon.join('\n'))
                } else if (custom.Kontraktnr) {
                  this.$helpers.showErrorAlert('Feil', custom.Kontraktnr.join('\n'))
                } else {
                  this.$helpers.showErrorAlert('Feil', 'Fant ingen objekter...')
                }
              })
              .then(() => {
                this.setFormProcessing(false)
                this.initialTextareaResize()

                this.saveLastSettings({
                  imageSize: this.imageSize,
                  avdelingsid: this.form.avdelingsid,
                  kontraktnr: this.form.kontraktnr,
                  code: this.form.code,
                  sort: this.form.sort,
                  direction: this.form.direction
                })
              })
          }
        })
    },
    fetch: function () {
      this.loading = true

      this.avdelingOpts.unshift({key: null, val: 'Laster...'})

      InstillingerService('avdeling').dropdown()
        .then((response) => {
          this.avdelingOpts = response.data
          this.avdelingOpts.unshift({ key: null, val: 'Alle', disabled: true })
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned avdeling innstillinger')
        })
        .then(() => {
          const stored = this.loadLastSettings()

          this.imageSize = stored.imageSize || 'image-small'
          this.form.avdelingsid = stored.avdelingsid || null
          this.form.kontraktnr = stored.kontraktnr || null
          this.form.code = stored.code || null
          this.form.sort = stored.sort || 'kunstner.Navn'
          this.form.direction = stored.direction || 'asc'

          this.loading = false
        })
    },
    onAuksjonSearchInput: function (query) {
      return AuksjonService.search(query, this.form.avdelingsid)
    },
    onAuksjonSearchSelected: function (item) {
      if (item) {
        this.form.code = item.Auksjon || null
      }
    }
  }
}
</script>

<style scoped>
div.manuslist-auction-info {
  margin: 0 0 1.5rem 0;
}
table.manuslist {
  width: 100%;
}
table.manuslist tr,
table.manuslist th,
table.manuslist td {
  padding: 0.25rem;
  vertical-align: top;
}

table.manuslist th {
  font-weight: bold;
}

table.manuslist thead tr {
  border-bottom: 1px solid;
  padding: 0;
  height: auto;
}

table.manuslist tr.header {
  height: 1.5rem;
  background: #ddd;
}
table.manuslist tr.header td {
  height: 1.5rem;
  vertical-align: center;
  background: #ddd;
}

table.manuslist .newline {
  margin-bottom: 1rem;
}

table.manuslist .pre {
  white-space: pre-line;
  overflow-wrap: break-word;
}

table.manuslist input.editable,
table.manuslist textarea {
  cursor: text;
  outline: none;
  border: none;
  background: none;
  box-shadow: none;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  height: 1.25rem;
  padding: 0;
}
table.manuslist textarea {
  resize: none;
  overflow-wrap: break-word;
  overflow: auto;
}

table.manuslist input.editable[disabled],
table.manuslist textarea[disabled] {
  color: #000;
  cursor: initial;
}

table.manuslist input.editable:not([disabled]):hover,
table.manuslist textarea:not([disabled]):hover {
  border: none;
  outline: none;
  -moz-box-shadow: 0 0 3px #bbb !important;
  -webkit-box-shadow: 0 0 3px #bbb !important;
  background: #eee;
}

table.manuslist input.editable:focus,
table.manuslist input.editable:focus:hover,
table.manuslist textarea:focus,
table.manuslist textarea:focus:hover
 {
  border: none;
  outline: none;
  -moz-box-shadow: 0 0 3px #bbb !important;
  -webkit-box-shadow: 0 0 3px #bbb !important;
  background: #fff;
}

table.manuslist input.editable::placeholder,
table.manuslist textarea::placeholder {
  color: #aaa;
  opacity: 0.8;
}

table.manuslist .icon-saving {
  display: none;
}

table.manuslist .icon-saving.active {
  display: block;
  position: absolute;
  top: 1rem;
  right: 0.4rem;
  width: 4.5rem;
  background: rgb(0 0 0 / 40%);
  color: #f8fffc;
  padding: 0.25rem;
  -moz-box-shadow: 0 0 3px #bbb !important;
  -webkit-box-shadow: 1px 1px 3px rgb(2 2 2 / 57%);
  font-weight: bold;
  text-align: center;
  border-radius: 0.9rem;
  z-index: 10;
}

table.manuslist.image-small .tr-div .td-div img {
  width: 32px;
  height: 32px;
  object-fit: contain;
  margin-top: 0px;
  margin-bottom: 0px;
  background-color: #fff;
}

table.manuslist.image-medium .tr-div .td-div img {
  width: 48px;
  height: 48px;
  object-fit: contain;
  background-color: #fff;
}

table.manuslist.image-large .tr-div .td-div img {
  width: 96px;
  height: 96px;
  object-fit: contain;
  background-color: #fff;
}

table.manuslist.image-none .tr-div .td-div img {
  display: none;
}

.tr-div{
  display: flex;
  flex-flow: row wrap;
  width: 100%;
}

.td-div{
  display: block;
  padding: 0.25rem;
}

thead .th-div-1,
.td-div.td-div-1{
  width: 5%;
}

thead .th-div-2,
.td-div.td-div-2{
  width: 25%;
}

thead .th-div-3,
.td-div.td-div-3{
  width: 10%;
}

thead .th-div-4,
.td-div.td-div-4{
  width: 11%;
  text-align: center;
}

thead .th-div-5,
.td-div.td-div-5{
  width: 11%;
  text-align: center;
}

thead .th-div-6,
.td-div.td-div-6{
  width: 11%;
  text-align: center;
}

thead .th-div-7,
.td-div.td-div-7{
  width: 11%;
  text-align: center;
}

thead .th-div-8,
.td-div.td-div-8{
  width: 11%;
  text-align: right;
}

thead .th-div-9,
.td-div.td-div-9{
  width: 5%;
  text-align: right;
}

.td-div.td-div-span-4{
  width: 57%;
}

/* Kunde table */
thead .th-div2-1,
.td-div.td-div2-1{
  width: 5%;
}

thead .th-div2-2,
.td-div.td-div2-2{
  width: 30%;
}

thead .th-div2-3,
.td-div.td-div2-3{
  width: 20%;
  text-align: center;
}

thead .th-div2-4,
.td-div.td-div2-4{
  width: 20%;
  text-align: center;
}

thead .th-div2-5,
.td-div.td-div2-5{
  width: 20%;
  text-align: right;
}

thead .th-div2-6,
.td-div.td-div2-6{
  width: 5%;
  text-align: right;
}

table.manuslist tr .tr-div,
table.manuslist tr .tr-div .td-div{
  /* padding: 0.25rem; */
  vertical-align: top;
}

table.manuslist tr .tr-div.header {
  height: 1.5rem;
  background: #ddd;
}

table.manuslist tr .tr-div.header .td-div {
  height: 1.5rem;
  vertical-align: center;
  background: #ddd;
}

table.manuslist tr .tr-div.header .td-div {
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
}

table tbody tr td{
  padding: 0;
  margin: 0;
}

table.manuslist.image-none thead .th-div-1,
table.manuslist.image-none thead .th-div2-1,
table.manuslist.image-none .tr-div .td-div-1,
table.manuslist.image-none .tr-div .td-div2-1 {
  width: 5%;
}
table.manuslist.image-small thead .th-div-1,
table.manuslist.image-small thead .th-div2-1,
table.manuslist.image-small .tr-div .td-div-1
table.manuslist.image-small .tr-div .td-div2-1 {
  width: 5%;
}

table.manuslist.image-medium thead .th-div-1,
table.manuslist.image-medium thead .th-div2-1,
table.manuslist.image-medium .tr-div .td-div-1,
table.manuslist.image-medium .tr-div .td-div2-1 {
  width: 8%;
}
table.manuslist.image-large thead .th-div-1,
table.manuslist.image-large thead .th-div2-1,
table.manuslist.image-large .tr-div .td-div-1,
table.manuslist.image-large .tr-div .td-div2-1 {
  width: 11%;
}

table.manuslist.image-medium thead .th-div2-3,
table.manuslist.image-medium .tr-div .td-div2-3,
table.manuslist.image-medium thead .th-div2-4,
table.manuslist.image-medium .tr-div .td-div2-4,
table.manuslist.image-medium thead .th-div2-5,
table.manuslist.image-medium .tr-div .td-div2-5 {
  width: 19%;
}

table.manuslist.image-medium thead .th-div-5,
table.manuslist.image-medium .tr-div .td-div-5,
table.manuslist.image-medium thead .th-div-6,
table.manuslist.image-medium .tr-div .td-div-6,
table.manuslist.image-medium thead .th-div-7,
table.manuslist.image-medium .tr-div .td-div-7 {
  width: 10%;
}

table.manuslist.image-medium .tr-div .td-div-span-4{
  width: 56%;
}

table.manuslist.image-large thead .th-div2-3,
table.manuslist.image-large .tr-div .td-div2-3,
table.manuslist.image-large thead .th-div2-4,
table.manuslist.image-large .tr-div .td-div2-4,
table.manuslist.image-large thead .th-div2-5,
table.manuslist.image-large .tr-div .td-div2-5 {
  width: 18%;
}

table.manuslist.image-large thead .th-div-5,
table.manuslist.image-large .tr-div .td-div-5,
table.manuslist.image-large thead .th-div-6,
table.manuslist.image-large .tr-div .td-div-6,
table.manuslist.image-large thead .th-div-7,
table.manuslist.image-large .tr-div .td-div-7 {
  width: 9%;
}

table.manuslist.image-large .tr-div .td-div-span-4{
  width: 55%;
}

/*
body {
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
}
*/

@media print {
  @page {
    orientation: landscape;
    margin: 4mm;
  }

  #manuslist-generator *, #manulist-generator > * {
    margin: 0;
    padding: 0;
    overflow: visible;
  }

  #tab-manusliste {
    display: grid;
    margin-bottom: 50vh;
  }
  #tab-manusliste tbody {
    display: table;
  }
  #manuslist-page-content > * {
    font-size: 12px;
  }

  #manuslist-page-content .print-header {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
  }

  table.manuslist > * {
    font-size: 10px;
  }

  table.manuslist input.editable::placeholder,
  table.manuslist textarea::placeholder {
    color: transparent;
    opacity: 0;
    text-shadow: none;
  }

  table.manuslist input.editable:not([disabled]):hover,
  table.manuslist textarea:not([disabled]):hover {
    border: none;
    outline: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    background: none;
  }

  table.manuslist input.editable:focus,
  table.manuslist input.editable:focus:hover,
  table.manuslist textarea:focus,
  table.manuslist textarea:focus:hover
  {
    border: none;
    outline: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    background: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Reports/ManuslistGenerator.vue